import React, { useState, useEffect } from "react";
import Axios from "axios";
import { withRouter } from "react-router";
import { LoginLayout } from "../../components/login/LoginLayout";

const IdCheck = props => {
    const [data, setData] = useState(null);
    const [natId, setNatId] = useState("");
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState("");

    // Load data on component mount
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch("api/General/CheckNatId");
                const result = await response.json();
                setData(result);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching ID data:", error);
                setError("Failed to load data. Please try again.");
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const validateEgyptianNationalId = (id, birthdate) => {
        const egyNatIdRegex = /^([2-3]{1})([0-9]{2})(0[1-9]|1[012])(0[1-9]|[1-2][0-9]|3[0-1])(0[1-4]|[1-2][1-9]|3[1-5]|88)[0-9]{3}([0-9]{1})[0-9]{1}$/;

        if (id.length !== 14) {
            return "Please enter your National ID. This number should be 14 digits.";
        }

        if (!egyNatIdRegex.test(id)) {
            return "The National ID is not valid.";
        }

        // Optional: Validate birthdate match (uncomment if needed)
        /*
        const birthDate = new Date(birthdate);
        let expectedPrefix = birthDate.getFullYear() < 2000 ? "2" : "3";
        expectedPrefix += birthDate.getFullYear().toString().substring(2, 4);
        expectedPrefix += (birthDate.getMonth() + 1).toString().padStart(2, "0");
        expectedPrefix += birthDate.getDate().toString().padStart(2, "0");

        if (id.substr(0, 7) !== expectedPrefix) {
            return "The National ID you entered does not match the birthdate in our records.";
        }
        */

        return null;
    };

    const validatePassport = (passportNumber) => {
        if (passportNumber.length < 4) {
            return "The Passport Number is not valid.";
        }
        return null;
    };

    const handleSubmit = async () => {
        if (!data) return;

        setError("");
        setSubmitting(true);

        // Validate based on nationality
        let validationError = null;
        if (data.nationCode === 11) {
            validationError = validateEgyptianNationalId(natId, data.birthdate);
        } else {
            validationError = validatePassport(natId);
        }

        if (validationError) {
            setError(validationError);
            setSubmitting(false);
            return;
        }

        // Submit the ID
        try {
            const response = await Axios.post(
                "api/General/UpdateNatId",
                JSON.stringify(natId),
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            );

            if (response.data === true) {
                window.location.href = "/";
            } else {
                setError("The ID you entered is not valid. Please try again.");
                setSubmitting(false);
            }
        } catch (error) {
            console.error("Error submitting ID:", error);
            setError("An error occurred while submitting. Please try again.");
            setSubmitting(false);
        }
    };

    if (loading) {
        return (
            <div>
                <LoginLayout>
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        <i className="fas fa-spinner fa-spin fa-3x"></i>
                        <p>Loading...</p>
                    </div>
                </LoginLayout>
            </div>
        );
    }

    if (!data) {
        return (
            <div>
                <LoginLayout>
                    <div className="alert alert-danger" style={{ textAlign: 'center' }}>
                        <p>Failed to load verification data. Please refresh the page.</p>
                    </div>
                </LoginLayout>
            </div>
        );
    }

    return (
        <div>
            {!props.isLogin && (
                <LoginLayout>
                    <div>
                        <h1 style={{ textAlign: 'center', marginBottom: '30px' }}>
                            ID Verification
                        </h1>

                        {error && (
                            <div className="alert alert-danger fade show m-b-10">
                                <span className="close" data-dismiss="alert" onClick={() => setError("")}>
                                    ×
                                </span>
                                {error}
                            </div>
                        )}

                        <div className="form-group m-b-15">
                            <label className="form-label">Registration Number</label>
                            <input
                                type="text"
                                className="form-control form-control-lg"
                                placeholder="Registration Number"
                                name="regnum"
                                readOnly
                                value={data.regNum || ""}
                            />
                        </div>

                        <div className="alert alert-warning fade show m-b-10" style={{ fontSize: 14, fontWeight: 600, direction: 'rtl', textAlign: 'right' }}>
                            <span className="close" data-dismiss="alert">
                                ×
                            </span>
                            يرجى تحديث بيانات الهوية الشخصية الخاصة بك للمتابعة
                        </div>

                        <div className="form-group m-b-15">
                            {data.nationCode === 11 ? (
                                <label className="form-label">
                                    National Identity Number <span>(الرقم القومى)</span>
                                </label>
                            ) : (
                                <label className="form-label">Passport Number</label>
                            )}

                            <input
                                type="text"
                                className="form-control form-control-lg"
                                placeholder={data.nationCode === 11 ? "National Identity Number" : "Passport Number"}
                                name="natId"
                                value={natId}
                                onChange={event => setNatId(event.target.value)}
                                disabled={submitting}
                                required
                            />
                        </div>

                        <button
                            onClick={handleSubmit}
                            className="btn btn-primary btn-block btn-lg"
                            disabled={submitting || !natId}
                        >
                            {submitting ? (
                                <span>
                                    <i className="fas fa-spinner fa-spin"></i> Submitting...
                                </span>
                            ) : (
                                "Submit"
                            )}
                        </button>
                    </div>
                </LoginLayout>
            )}
        </div>
    );
};

export default withRouter(IdCheck);




// WEBPACK FOOTER //
// ./src/pages/Id/Id.js